/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HotelSellChangeReportApiRequest } from '../../models/hotel-sell-change-report-api-request';

export interface ApiHotelHotelSellChangeReportPost$Params {
      body: HotelSellChangeReportApiRequest
}

export function apiHotelHotelSellChangeReportPost(http: HttpClient, rootUrl: string, params: ApiHotelHotelSellChangeReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiHotelHotelSellChangeReportPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiHotelHotelSellChangeReportPost.PATH = '/api/hotel/HotelSellChangeReport';
